<template>
  <div>
    <a-row :gutter="[16,16]">
      <a-col v-if="readOnly" v-bind="colSpan">
        <a-form-model-item :label="$t('Tipo licencia')" has-feedback>
          <a-select v-model="selectItem" style="width: 100%">
            <a-select-option v-for="i in listCheck" :key="i">
              {{ i }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <template v-if="selectItem==='IRP'">
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('IRP')" prop="irp" has-feedback>
            <a-input style="width: 100%"
                     v-model="iPlano.irp"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('Fecha Ini Irl')" prop="fecha_ini_irl" has-feedback>
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-model="iPlano.fecha_ini_irl"/>
          </a-form-model-item>
        </a-col>
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('Fecha fin Irl')" prop="fecha_fin_irl" has-feedback>
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-model="iPlano.fecha_fin_irl"/>
          </a-form-model-item>
        </a-col>
      </template>
      <template v-else-if="selectItem==='VAC'">
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('VAC')" prop="vac" has-feedback>
            <a-input style="width: 100%"
                     v-model="iPlano.vac"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('Fecha Ini')" prop="fecha_ini_vacl" has-feedback>
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-model="iPlano.fecha_ini_vacl"/>
          </a-form-model-item>
        </a-col>
        <a-col v-bind="colSpan">
          <a-form-model-item :label="$t('Fecha Fin')" prop="fecha_fin_vacl" has-feedback>
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-model="iPlano.fecha_fin_vacl"/>
          </a-form-model-item>
        </a-col>
      </template>
      <template v-else>
        <template v-if="withDate">
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Ini')" has-feedback>
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-model="fecha_inicio"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Fin')" has-feedback>
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-model="fecha_fin"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col v-if="readOnly" v-bind="colSpan">
          <a-button icon="plus" shape="circle" @click="addRecord">
          </a-button>
        </a-col>
      </template>
    </a-row>
    <a-table
      v-bind="tbConfig"
      rowKey="tipo_licencia"
      :columns="columns"
      :data-source="getRecord">
      <span v-if="readOnly" slot="action" slot-scope="text, record">
        <a><a-icon type="edit" theme="twoTone" two-tone-color="blue" @click="updateLic(record)"/></a>
        <a><a-icon type="delete" theme="twoTone" two-tone-color="red" @click="deleteLic(record)"/></a>
      </span>
    </a-table>
  </div>
</template>
<script>
  const listCheck = [
    'SLN', 'IGE', 'LMA',
    'VAC', 'VCT', 'ING',
    'RET', 'VSP', 'COR',
    'AVP', 'TAE', 'TDE',
    'VST', 'TAP', 'IRP'
  ]

  const columns = [
    {
      title: 'Tipo licencia',
      dataIndex: 'tipo_licencia',
      key: 'tipo_licencia'
    },
    {
      title: 'Fecha inicio',
      dataIndex: 'fecha_inicio',
      key: 'fecha_inicio'
    },
    {
      title: 'Fecha fin',
      key: 'fecha_fin',
      dataIndex: 'fecha_fin'
    },
    {
      title: 'Action',
      key: 'action',
      scopedSlots: {customRender: 'action'}
    }
  ]

  const NO_DISPONIBLE = 'No disponible'

  export default {
    props: ['iPlano', 'readOnly'],
    data () {
      return {
        fecha_inicio: null,
        fecha_fin: null,
        colSpan: {
          sm: 24,
          md: 6
        },
        selectItem: null,
        selectValue: null,
        listCheck,
        tbConfig: {
          scroll: {x: 'max-content'},
          bordered: true,
          size: 'small',
          pagination: {
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        columns
      }
    },
    methods: {
      updateLic (record) {
        this.selectItem = record.tipo_licencia
        this.fecha_inicio = record.fecha_inicio
        this.fecha_fin = record.fecha_fin
        this.changeStatus(true, record, true)
      },
      deleteLic (record) {
        this.changeStatus(false, record, true)
      },
      addRecord () {
        this.changeStatus(true)
      },
      changeStatus (status, record = null, isDeleteOrUpdate = false) {
        let value = isDeleteOrUpdate ? record.tipo_licencia : this.selectItem
        switch (value) {
          case 'SLN':
            this.iPlano.sln = status
            this.iPlano.fecha_ini_sln = isDeleteOrUpdate ? record.fecha_inicio : this.fecha_inicio
            this.iPlano.fecha_fin_sln = isDeleteOrUpdate ? record.fecha_fin : this.fecha_fin
            break
          case 'IGE':
            this.iPlano.ige = status
            this.iPlano.fecha_ini_ige = isDeleteOrUpdate ? record.fecha_ini_ige : this.fecha_inicio
            this.iPlano.fecha_fin_ige = isDeleteOrUpdate ? record.fecha_fin : this.fecha_fin
            break
          case 'LMA':
            this.iPlano.lma = status
            this.iPlano.fecha_ini_lma = isDeleteOrUpdate ? record.fecha_inicio : this.fecha_inicio
            this.iPlano.fecha_fin_lma = isDeleteOrUpdate ? record.fecha_fin : this.fecha_fin
            break
          case 'VCT':
            this.iPlano.vct = status
            this.iPlano.fecha_ini_vct = isDeleteOrUpdate ? record.fecha_inicio : this.fecha_inicio
            this.iPlano.fecha_fin_vct = isDeleteOrUpdate ? record.fecha_fin : this.fecha_fin
            break
          case 'ING':
            this.iPlano.ing = status
            this.iPlano.fecha_ingreso = isDeleteOrUpdate ? record.fecha_inicio : this.fecha_inicio
            this.fecha_fin = null
            break
          case 'RET':
            this.iPlano.ret = status
            this.iPlano.fecha_retiro = isDeleteOrUpdate ? record.fecha_inicio : this.fecha_inicio
            this.fecha_fin = null
            break
          case 'VSP':
            this.iPlano.vsp = status
            this.iPlano.fecha_ini_vsp = this.fecha_inicio
            this.fecha_fin = null
            break
          case 'COR':
            this.iPlano.cor = status
            break
          case 'AVP':
            this.iPlano.avp = status
            break
          case 'TDP':
            this.iPlano.tdp = status
            break
          case 'TAE':
            this.iPlano.tae = status
            break
          case 'TDE':
            this.iPlano.tde = status
            break
          case 'VST':
            this.iPlano.vst = status
            break
          case 'TAP':
            this.iPlano.tap = status
            break
        }
      }
    },
    computed: {
      getRecord () {
        return [
          {
            'tipo_licencia': 'SLN',
            'fecha_inicio': this.iPlano.fecha_ini_sln && moment(this.iPlano.fecha_ini_sln).format('YYYY-MM-DD'),
            'fecha_fin': this.iPlano.fecha_fin_sln && moment(this.iPlano.fecha_fin_sln).format('YYYY-MM-DD'),
            'value': this.iPlano.sln
          },
          {
            'tipo_licencia': 'IGE',
            'fecha_inicio': this.iPlano.fecha_ini_ige && moment(this.iPlano.fecha_ini_ige).format('YYYY-MM-DD'),
            'fecha_fin': this.iPlano.fecha_fin_ige && moment(this.iPlano.fecha_fin_ige).format('YYYY-MM-DD'),
            'value': this.iPlano.ige
          },
          {
            'tipo_licencia': 'LMA',
            'fecha_inicio': this.iPlano.fecha_ini_lma && moment(this.iPlano.fecha_ini_lma).format('YYYY-MM-DD'),
            'fecha_fin': this.iPlano.fecha_ini_lma && moment(this.iPlano.fecha_fin_lma).format('YYYY-MM-DD'),
            'value': this.iPlano.lma
          },
          {
            'tipo_licencia': 'VCT',
            'fecha_inicio': this.iPlano.fecha_ini_vct && moment(this.iPlano.fecha_ini_vct).format('YYYY-MM-DD'),
            'fecha_fin': this.iPlano.fecha_fin_vct && moment(this.iPlano.fecha_fin_vct).format('YYYY-MM-DD'),
            'value': this.iPlano.vct
          },
          {
            'tipo_licencia': 'ING',
            'fecha_inicio': this.iPlano.fecha_ingreso && moment(this.iPlano.fecha_ingreso).format('YYYY-MM-DD'),
            'fecha_fin': NO_DISPONIBLE,
            'value': this.iPlano.ing
          },
          {
            'tipo_licencia': 'RET',
            'fecha_inicio': this.iPlano.fecha_retiro && moment(this.iPlano.fecha_retiro).format('YYYY-MM-DD'),
            'fecha_fin': NO_DISPONIBLE,
            'value': this.iPlano.ret
          },
          {
            'tipo_licencia': 'VSP',
            'fecha_inicio': this.iPlano.fecha_ini_vsp && moment(this.iPlano.fecha_ini_vsp).format('YYYY-MM-DD'),
            'fecha_fin': NO_DISPONIBLE,
            'value': this.iPlano.vsp
          },
          {
            'tipo_licencia': 'COR',
            'value': this.iPlano.cor,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'AVP',
            'value': this.iPlano.avp,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'TDP',
            'value': this.iPlano.tdp,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'TAE',
            'value': this.iPlano.tae,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'TDE',
            'value': this.iPlano.tde,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'VST',
            'value': this.iPlano.vst,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          },
          {
            'tipo_licencia': 'TAP',
            'value': this.iPlano.tap,
            'fecha_inicio': NO_DISPONIBLE,
            'fecha_fin': NO_DISPONIBLE
          }
        ].filter(r => r.value)
      },
      withDate () {
        return this.listCheck.slice(0, 8).includes(this.selectItem)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/SelectNovedades.vue